/** Set when a partner user opens the dealer portal for a specific dealership. */
export const PARTNER_DEALER_PORTAL_TARGET_KEY = "automap_partner_dealer_portal_target";

export function rememberPartnerDealerPortalTarget(dealerId) {
  if (!dealerId) return;
  try {
    sessionStorage.setItem(PARTNER_DEALER_PORTAL_TARGET_KEY, String(dealerId));
  } catch {
    // sessionStorage may be unavailable in some contexts
  }
}

export function readPartnerDealerPortalTarget() {
  try {
    return sessionStorage.getItem(PARTNER_DEALER_PORTAL_TARGET_KEY);
  } catch {
    return null;
  }
}

export function clearPartnerDealerPortalTarget() {
  try {
    sessionStorage.removeItem(PARTNER_DEALER_PORTAL_TARGET_KEY);
  } catch {
    // ignore
  }
}
